import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FrameworksHero from './components/FrameworksHero';
import FrameworksGrid from './components/FrameworksGrid';
import FrameworkDetails from './components/FrameworkDetails';

export default function FrameworksPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": `${siteUrl}/frameworks`,
        "name": "Growth Frameworks | Force Multiplier",
        "description": "Proven frameworks for identifying and removing structural constraints that limit company growth. Strategic tools for founder-led companies.",
        "url": `${siteUrl}/frameworks`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "Force Multiplier",
          "url": siteUrl
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Frameworks",
            "item": `${siteUrl}/frameworks`
          }
        ]
      }
    ]
  };

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <SEOHead
        title="Growth Frameworks | Force Multiplier"
        description="Proven frameworks for identifying and removing structural constraints that limit company growth. Strategic tools for founder-led companies."
        canonicalPath="/frameworks"
        schema={schema}
      />
      <div className="relative min-h-screen bg-black text-white overflow-hidden">
        <Navigation />
        
        {/* Continuous Background Grid System */}
        <div className="fixed inset-0 pointer-events-none z-0">
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px]"></div>
          <div className="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-accent-blue/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-1/4 right-1/4 w-[600px] h-[600px] bg-accent-blue/10 rounded-full blur-[120px]"></div>
        </div>

        <div className="relative z-10">
          <FrameworksHero />
          <FrameworksGrid />
          <FrameworkDetails />
          <Footer />
        </div>
      </div>
    </Suspense>
  );
}